import { Component, OnInit } from '@angular/core';
import { BaseDynamicFormComponent } from 'src/app/common/components/dynamic-form-v2/components/base-dynamic-form/base-dynamic-form.component';
import { InputFieldType } from 'src/app/common/components/dynamic-form-v2/enums/InputFieldType';
import { DynamicInputType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicInputType';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import QAUserGroupsDTO from '../dtos/QAUserGroupsDTO';
@Component({
  selector: 'app-user-groups-forms-v2',
  templateUrl: './qa-user-groups-forms-v2.component.html',
  styleUrls: ['./qa-user-groups-v2.component.sass']
})
export class QAUserGroupsFormsV2Component extends BaseDynamicFormComponent implements OnInit {

  qaUserGroupRecord: QAUserGroupsDTO = new QAUserGroupsDTO();
  constructor() { 
    super();
  }

  ngOnInit()
  {
    this.fields =
    [
      {
        title: "QA User Group Data",
        fields:
        [
          {
            name: "Name",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.TextInput],
            clearField: true,
            key: 'name',
            isRequired: true,
            label: 'Name'
          },
          {
            name: "QA Users",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.MultiSelect],
            clearField: true,
            key: 'users_ref',
            label: 'QA Users',
            labelKeys: ['id', 'identifier'],
            optionValue: '_id',
            optionLabel: 'identifier',
            optionDisabled: 'disabled',
            filter: true,
            options: {
              fieldName: 'users_ref',
              apiController: 'qa-users',
              select: 'id identifier',
              autopopulate: false,
            },
            columnWidth: 12
          },
        ],
        type: DynamicCardType.Card
      }
    ]

    this.title = "QA User Group";
    this.viewRoute = 'qa-user-groups';
    this.isLoading = false; 
  }

}
